import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCallbackStatus.ts
var t = () => e("callbackStatus");
//#endregion
export { t as useTrCallbackStatus };
